import directives from './module';
import {ObjectId} from '../services/ObjectId';
import {Observer} from '../services/ViewPortSvc';

/**
 * Add class to an element then add directive with value which contains words from previous class
 */
directives.directive('appearAnimation', ($rootScope: ng.IRootScopeService,
                                         ViewPortSvc: Observer) =>
    (scope: any, element: ng.IAugmentedJQuery, attrs: {appearAnimation: string}) => {
        if (!element[0].id) element[0].id = ObjectId.get();
        const id: string        = element[0].id;
        const className: string = attrs.appearAnimation;
        const shouldDisponse    = attrs.hasOwnProperty('andDisposeAnimation');

        if (/prerender/.test(navigator.userAgent)) {
            element[0].classList.add(className);
            return;
        }

        ViewPortSvc.subscribe(element[0]);
        setTimeout(() => ViewPortSvc.checker(), 0);

        const destroy = $rootScope.$on('onScreen:' + id, _.once(() => {
            if (shouldDisponse) {
                const initialName = className.replace(/--.*$/, '');
                const dispose     = _.once(() => {
                    const toRemove = Array.apply(null, element[0].classList)
                        .filter((a: string) => a.includes(initialName))
                        .concat(className);
                    element[0].classList.remove(...toRemove);
                    element[0].removeEventListener('transitionend', dispose);
                });
                element[0].addEventListener('transitionend', dispose);
            }
            element[0].classList.add(className);
            ViewPortSvc.subscribe(element[0]);
            destroy();
            // scope.$destroy();
        }));
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/AppearAnimation.ts